import React from 'react'
import { useTranslation } from "react-i18next";

const NewRadioButtonGeneric = ({ handleChange, values, errors, placeholderVal, field, max_length, moduleText, occupation = 6, css_class}) => {
  const { t } = useTranslation();

  return (
    <div className={`col-md-${occupation}`}>
      <label htmlFor={field} className="form-label tit-view">
      {t(`${moduleText}.short.${field}`)}
      </label>
      <div className="control">
        <div onChange={(event) => handleChange(event, field)}>
            <input readOnly type="radio" value="yes" name={field} checked={( values[field] === true) || ( values[field] === "yes") } /> Si
            <input readOnly type="radio" value="no" name={field} checked={(values[field] === false) || (values[field] === "no") } /> No
          </div>

        {errors[field] && <pre> <p className="help text-danger">{errors[field]}</p> </pre>}
      </div>
    </div>
  )
}

export default NewRadioButtonGeneric;

